import React, { useCallback, useEffect, useState } from 'react';
import { Button, Chip, Typography, Box, Paper } from '@material-ui/core';
import { CustomerRequest } from 'components/CustomerRequest';
import api from 'services/api';
import { useSnackbar } from 'hooks';
import { format, parseISO } from 'date-fns';
import {
  formatPhoneNumber,
  isWaitress,
  requestStatusLabelHelper,
} from 'helpers';
import PrintRequest from 'components/PrintRequest';

function formatCreatedDate(date) {
  return format(parseISO(date), 'dd/MM/yyyy HH:mm');
}

function Header({ request }) {
  return (
    <CustomerRequest.Header
      requestNumber={request.request_number ?? request.id}
    >
      <Chip label={requestStatusLabelHelper(request.status)} />
    </CustomerRequest.Header>
  );
}

function CustomerAddress({ address }) {
  return (
    <span style={{ fontSize: '12px' }}>
      {`${address.address}, Nº ${address.number} - ${address.complement} - ${address.district} - ${address.zip_code} - ${address.city}/${address.state}`}
    </span>
  );
}

export function RequestProductList({ requestId, onUpdate }) {
  const [request, setRequest] = useState();
  const { openSnackbar } = useSnackbar();

  const fetchRequestsById = useCallback(
    async (id) => {
      try {
        const res = await api.get(`/requests/${id}`);

        setRequest(res.data.object);
        // eslint-disable-next-line no-unused-vars
      } catch (err) {
        openSnackbar('Erro ao buscar detalhes do pedido.', 'error');
      }
    },
    [openSnackbar],
  );

  useEffect(() => {
    fetchRequestsById(requestId);
  }, [fetchRequestsById, requestId]);

  const updateStatus = useCallback(
    async (id, statusId) => {
      try {
        await api.put(`/requests/${id}`, {
          status: statusId,
        });

        if (onUpdate) {
          onUpdate();
        }

        openSnackbar('Atualizado com sucesso');
      } catch (err) {
        console.log('deu ruim', err);
        openSnackbar('Não foi possível atualizar', 'error');
      }
    },
    [openSnackbar],
  );

  if (!request) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <CustomerRequest request={request}>
      <Header request={request} />

      <CustomerRequest.Content>
        <CustomerRequest.Info>
          <CustomerRequest.InfoData>
            <CustomerRequest.InfoDataLabel>
              Data do Pedido
            </CustomerRequest.InfoDataLabel>
            {formatCreatedDate(request.created_at)}
          </CustomerRequest.InfoData>

          {request.user ? (
            <>
              <CustomerRequest.InfoData>
                <CustomerRequest.InfoDataLabel>
                  {isWaitress(request.user.profile.id) ? 'Garçom' : 'Cliente'}
                </CustomerRequest.InfoDataLabel>

                <CustomerRequest.InfoDataText>
                  {request.user.name}
                </CustomerRequest.InfoDataText>
              </CustomerRequest.InfoData>

              {!isWaitress(request.user.profile.id) && (
                <CustomerRequest.InfoData>
                  <CustomerRequest.InfoDataLabel>
                    Telefone
                  </CustomerRequest.InfoDataLabel>
                  {formatPhoneNumber(request.user.phone.number)}
                </CustomerRequest.InfoData>
              )}
            </>
          ) : null}

          {request.request_type_id === 1 ? (
            <CustomerRequest.InfoData>
              <CustomerRequest.InfoDataLabel>
                Mesa
              </CustomerRequest.InfoDataLabel>
              {request.table.number}
            </CustomerRequest.InfoData>
          ) : null}

          {request.request_type_id === 2 ? (
            <CustomerRequest.InfoData>
              <CustomerRequest.InfoDataLabel>
                Para Entrega
              </CustomerRequest.InfoDataLabel>
              {request.user && (
                <CustomerAddress address={request.user.users_address} />
              )}
            </CustomerRequest.InfoData>
          ) : null}

          {request.request_type_id === 3 ? (
            <CustomerRequest.InfoData>
              <b>Pedido para Retirar</b>
            </CustomerRequest.InfoData>
          ) : null}
        </CustomerRequest.Info>

        <CustomerRequest.ProductList productList={request.request_products} />

        <CustomerRequest.Footer totalPrice={request.total_price} />
      </CustomerRequest.Content>

      <Paper
        component={Box}
        variant="outlined"
        p={1}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {request.status === 1 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 2)}
          >
            Trocar para em preparo
          </Button>
        )}

        {request.request_type_id == 1 && request.status === 2 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 3)}
          >
            Trocar para concluído
          </Button>
        )}

        {request.request_type_id == 2 && request.status === 2 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 4)}
          >
            Trocar para Saiu para entrega
          </Button>
        )}

        {request.request_type_id == 2 && request.status === 4 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 3)}
          >
            Trocar para concluído
          </Button>
        )}

        {request.request_type_id == 3 && request.status === 2 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 5)}
          >
            Trocar para aguardando retirada
          </Button>
        )}

        {request.request_type_id === 3 ? (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 5)}
          >
            Trocar para aguardando retirada
          </Button>
        ) : null}

        {request.request_type_id == 3 && request.status === 2 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 5)}
          >
            Trocar para aguardando retirada
          </Button>
        )}

        {request.request_type_id == 3 && request.status === 5 && (
          <Button
            color="primary"
            fullWidth
            onClick={() => updateStatus(request.id, 3)}
          >
            Trocar para concluído
          </Button>
        )}

        <PrintRequest request={request} />
      </Paper>
    </CustomerRequest>
  );
}
